import Vue from "vue";

export function pageAllQualificationApi(params, success,complete) {
    let url = "/admin/web/qualification/pageAllQualification";
    Vue.prototype.alexPost(url, params, success,null,complete);
}
